import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import { useCallback } from "react";
import { toast } from "react-toastify";
import useSWRMutation from "swr/mutation";
import { useDealContext, useMutateDealContext } from "~/context/DealContext";
import { isSuccess } from "~/utils/api/api_handler";
import {
	paths,
	withdrawSelf
} from "~/utils/api/vendors/deals/DealPartnerAssignment";

type Props = DeepReadonly<{
	handleClose: () => void;
}>;

export function WithdrawSelfAssignmentModal({ handleClose }: Props) {
	const deal = useDealContext();
	const mutateDeal = useMutateDealContext();

	const { trigger, isMutating } = useSWRMutation(paths.withdraw(deal.id), () =>
		withdrawSelf(deal.id)
	);

	const onSubmit = useCallback(async () => {
		const result = await trigger();
		if (isSuccess(result)) {
			await mutateDeal();
			toast.success("自社での実施を解除しました。");
			handleClose();
		} else {
			toast.error(result.message ?? "エラーが発生しました。");
		}
	}, [trigger, mutateDeal, handleClose]);

	return (
		<Modalv2 isOpen onClose={handleClose} size="s">
			<ModalHeader title="自社での実施を解除" />
			<ModalBody>
				<Paragraph>自社での実施を解除します。</Paragraph>
			</ModalBody>
			<ModalFooter
				leftArea={
					<Button
						disabled={isMutating}
						onClick={handleClose}
						variant="secondary"
					>
						キャンセル
					</Button>
				}
				rightArea={
					<Button loading={isMutating} onClick={onSubmit} variant="danger">
						解除
					</Button>
				}
			/>
		</Modalv2>
	);
}
